<template>
  <div class="list_index">
      <div class="nav">
        <el-radio-group v-model="select_info" class="radio-left" size="small">
            <el-radio-button label="0">机组数据</el-radio-button>
            <el-radio-button label="1">趋势图</el-radio-button>
            <el-radio-button label="2">事件记录
                <el-badge v-if="count != 0" :value="count" class="item"> </el-badge>
            </el-radio-button>
            <el-radio-button label="3">报警参数</el-radio-button>
        </el-radio-group>
        <el-button type="primary" class="yl-button" @click="toRealInfo('2D','气路')">气路组态</el-button>
        <el-button type="primary" class="yl-button" @click="toRealInfo('2D','油路')">油路组态</el-button>
        <el-button type="primary" class="yl-button" @click="toRealInfo('3D','')">3D组态</el-button>
        <span :class="color">{{times}}</span>
        <span v-if="select_info == '0' || select_info == '3'" class="text m20">刷新频率：</span>
        <el-select v-if="select_info == '0' || select_info == '3'" v-model="interval" class="w-158" size="small" @change="intervalChange">
            <el-option label="1" value="1"></el-option>
            <el-option label="5" value="5"></el-option>
            <el-option label="10" value="10"></el-option>
            <el-option label="15" value="15"></el-option>
            <el-option label="20" value="20"></el-option>
            <el-option label="30" value="30"></el-option>
            <el-option label="60" value="60"></el-option>
        </el-select>
        <span v-if="select_info == '0' || select_info == '3'" class="text m20">秒</span>
      </div>
      <div class="main" v-if="select_info == '0'">
          <realData ref="realDatas" @time="time" />
      </div>
      <div class="main" v-if="select_info == '1'">
          <charts />
      </div>
      <div class="main" v-if="select_info == '2'">
          <alert />
      </div>
      <div class="main" v-if="select_info == '3'">
          <alertData ref="alertDatas" />
      </div>
  </div>
</template>

<script>
import DataService from '@/api/data'
import charts from './TrendChart.vue'
import alert from './alert.vue'
import realData from './realData.vue'
import alertData from './alertData.vue'
export default {
  components:{
      charts,
      alert,
      realData,
      alertData
  },
  data(){
      return{
        interval:'5',
        select_info:'0',
        serial_number:'',
        equipmentModel:'',
        geteway_name:'',
        item_no:'',
        region:'',
        customer:'',
        stable:'',
        device_rank:'',
        count:0,
        timer:'',
        color:'',
        times:'',
      }
  },
  methods:{
      intervalChange(e){
          this.updateTimer()
      },
      //修改定时器时间
      updateTimer(){
          let _this = this;
          DataService.updateTimer({
            user_id:this.$store.state.user_id,
            second:this.interval
          }).then(res=>{
              console.log(this.$refs)
              this.$message.success('修改成功')
              if(this.select_info == '0'){
                _this.$refs.realDatas.getTimer('update')
              }else if(this.select_info == '3'){
                _this.$refs.alertDatas.getTimer('update')
              }
          }).catch(err=>{
              this.$message.error(err.msaage)
          })
      },
      //获取定时器时间
      getTimer(){
          DataService.queryTimer({
              user_id:this.$store.state.user_id
          }).then(res=>{
              this.interval = res.data
          }).catch(err=>{
              this.$message.error(err.msaage)
          })
      },
      time(time,color){
        this.times = time;
        this.color = color;
      },
      toRealInfo(type,name){
        var templateName
        switch (this.device_rank) {
            case '0':
                templateName = '123'//随便填，让组态页面能够监听到路由变化
                break;
            case '1':
                templateName = '一级离心机' + name
                break;
            case '2':
                templateName = '二级离心机' + name
                break;
            case '3':
                templateName = '三级离心机' + name
                break;
            case '4':
                templateName = '四级离心机' + name
                break;
            default:
                break;
        }
        let path = ''
        if(type == '2D'){
            path = '/getewayRealInfo'
        }else{
            path = '/getewayRealInfo_3D'
        }
        let route = this.$router.resolve({
            path:path,
            query:{
                serial_number:this.serial_number,
                templateName:templateName,
                equipment_model:this.stable,
                status:0,
            }
        })
        window.open(route.href,'_blank')
      },
      //获取告警数据
        getAlarmData(){
            DataService.getAlarmData({
                user_id:this.$store.state.user_id,
                serialNumber:this.serial_number,
                status:0,
                page:1,
                size:10,
                user_token:this.$store.state.token
            }).then(res=>{
                this.count = res.data.count;
            }).catch(err=>{
                this.$message.error(err.msaage)
            })
        }
  },
  created(){
      if(this.$route.query.serial_number){
       this.serial_number = this.$route.query.serial_number;
       this.equipmentModel = this.$route.query.equipmentModel;
       this.geteway_name = this.$route.query.geteway_name;
       this.item_no = this.$route.query.item_no;
       this.region = this.$route.query.region;
       this.customer = this.$route.query.customer;
       this.stable = this.$route.query.stable;
       this.device_rank = this.$route.query.device_rank;
    }
  },
  mounted(){
    this.getTimer()
    this.getAlarmData()
    let _this = this;
    this.timer = setInterval(function(){
      _this.getAlarmData()
	  }, 5000);
  },
  beforeDestroy(){
    clearInterval(this.timer)
  },
}
</script>

<style lang="scss" scoped>
.radio-left{
    margin-right: 20px;
}
.item{
  position: absolute;
  right: 12px;
  bottom: 8px;
}
.text{
  font-size: 16px;
}
.green{
  color: greenyellow;
  margin-left: 20px;
  font-size: 20px;
}
.red{
  color: red;
  margin-left: 20px;
  font-size: 20px;
}
</style>